var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isLoading ? _c('b-nav', {
    staticClass: "menu-component",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "vertical": ""
    }
  }, _vm._l(_vm.visibleMenuItems, function (menuItem, index) {
    var _menuItem$target;
    return _c(_vm.isSubHeader(menuItem) ? 'b-nav-text' : 'b-nav-item', {
      key: index,
      tag: "component",
      class: Object.assign({}, menuItem.class, {
        active: _vm.isActive(menuItem)
      }),
      attrs: {
        "to": !_vm.isLink(menuItem) ? menuItem.to : undefined,
        "href": _vm.isLink(menuItem) ? menuItem.to : undefined,
        "target": (_menuItem$target = menuItem.target) !== null && _menuItem$target !== void 0 ? _menuItem$target : ''
      }
    }, [_vm.isSubHeader(menuItem) ? _c('strong', {
      staticClass: "menu-header"
    }, [_vm._v(" " + _vm._s(_vm.$t(menuItem.title)) + " ")]) : _c('span', {
      staticClass: "menu-item"
    }, [_c('i', {
      staticClass: "metismenu-icon font-size-xlg opacity-5",
      class: menuItem.icon
    }), _c('span', {
      staticClass: "d-inline-block pl-3 align-top"
    }, [_vm._v(" " + _vm._s(_vm.$t(menuItem.title)) + " ")])])]);
  }), 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }